import { lazy } from "react";

export { SAVE_OPPORTUNITIES_PATH } from "./save-opportunities-path";
export const SaveOpportunitiesPage = lazy(
  () => import("./save-opportunities-page"),
);
